import React from 'react';
import Discipline from "../../../models/Discipline";
import FlipMove from "react-flip-move";
import ItemSelectModal from "../../../components/ItemSelectModal";
import Component from "../../../components/Component";
import {SearchInput} from "../../../components/form/SearchInput";
import {Empty} from "antd";
import NEWSkillFormButton from '../../profiles/components/NEWSkillFormButton';

class ProjectSkillsForm extends Component {
    constructor(props) {
        super(props);
        let allPhaseDisciplines = TB.flatMapDeep(props.project.phases, phase => TB.flatMap(phase.deliverables, 'disciplines'));

        this.state = {
            disciplines: allPhaseDisciplines || [],
            isLoading: false,
            search: '',
            suggestedSkills: []
        }
    }

    searchProps() {
        return {
            name: 'search',
            style: styles.field,
            label: false,
            placeholder: 'Type here to search all skills',
            type: 'search',
            searchType: 'skills',
            valueLabelDisplay: 'name',
            disabled: this.props.disabled,
            searchRequestEndpoint: '/api/talent-skills/search',
            required: false,
            autoComplete: 'off',
            columns: 12,
            onSearch: (search) => this.setState({search}),
            onSuggestionsFetched: ((suggestedSkills, value) => {
                let suggested = [...suggestedSkills]
                // if (!suggested?.length && value?.length > 3) {
                //     suggested.push({name: value})
                // }

                let selectedIds = this.projectSkillIds()
                suggested = TB.filter(suggested, skill => !selectedIds.includes(skill.id));

                suggested = TB.map(suggested, skill => ({...skill, is_extra: true}))
                this.setState({suggestedSkills: suggested})
            }),
            onLoading: (isLoading => {
                this.setState({isLoading})
            }),
            getValue: () => this.state.search || '',
            // searchWhenEmpty: 'a'
        }
    }

    projectSkillIds() {
        return TB.map(this.props.project?.skills || [], skill => skill.id || skill.name);
    }

    skillsForDiscipline(discipline) {
        let disciplineSkills = Discipline.skillsFor(discipline?.id);

        let positionSkills = this.projectSkillIds();

        return TB.filter(
            disciplineSkills,
            skill => !positionSkills.includes(skill.id)
        )
    }

    async selectSkill(skill) {
        let skills = [...(this.props.project?.skills || [])];

        let identifier = skill.id ? 'id' : 'name'
        if (TB.isDefined(skill.importance)) {
            if (TB.find(skills, [identifier, skill[identifier]])) {
                skills = TB.map(skills, sk => {
                    if (sk[identifier] === skill[identifier]) {
                        return {...skill};
                    }
                    return sk;
                });
            } else {
                skills.push(skill);
            }
        } else {
            skills = TB.xorBy(skills, [skill], identifier);
        }

        return this.props.onUpdate(skills);
    }

    showModal() {
        let categories = TB.map([...laravel.discipline_categories], (category = {}) => {
            return {
                ...category,
                // TODO Change with updated discipline filters for client/talent
                disciplines: category.disciplines,//TB.filter(category.disciplines, ['is_contractable', true])
            }
        })

        return TB.event("Modal@show", {
            title: 'Choose a role below you want to see common skills for',
            content: (
                <ItemSelectModal
                    fieldName="disciplines"
                    selectText="Select Role"
                    onSelectItem={async (discipline) => {
                        await this.promisedState({disciplines: [discipline]})
                        await TB.event("Modal@hide", true);
                    }}
                    multiSelect={false}
                    isDisabled={false}
                    categoryHeader="Role Category"
                    hideModal={() => TB.event("Modal@hide", true)}
                    itemHeader={`${laravel.platform_name} Role`}
                    items={categories}
                />
            )
        })
    }


    render() {


        const projectSkills = this.projectSkillIds();

        let {
            suggestedSkills,
            search,
            disciplines
        } = this.state;


        let suggested = TB.filter(suggestedSkills || [], skill => !projectSkills.includes(skill.id || skill.name));
        return (
            <div className="field-section">

                <div className="project-discipline-skills-form">

                    <div className="position-skill-divider"/>

                    <SearchInput
                        {...this.searchProps()}
                        value={search}
                        setValue={value => {
                            this.promisedState({search: value})
                        }}/>
                </div>

                <div className="project-skill-search-results">
                    <div className="discipline-skills-container skill-importance-container gap-3">

                        {search === '' && !suggested?.length && (
                            <div className="flex flex-col self-stretch flex-grow items-center justify-center mx-auto">
                                <Empty description="Start searching to view skills" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            </div>
                        )}
                        {(search === '' || suggested?.length > 0) ? (
                            <FlipMove typeName={null} maintainContainerHeight={true}>
                                {TB.map(suggested, skill => (
                                    <div key={`skill-${skill.id || skill.name}`}>
                                        <NEWSkillFormButton
                                            skill={skill}
                                            valuePropName={'importance'}
                                            disabled={this.props.disabled}
                                            scoringOptions={`laravel.importance_levels`}
                                            onChange={this.selectSkill.bind(this)}
                                            className="min-w-[115px]"
                                        />
                                    </div>
                                ))}
                            </FlipMove>
                        ) : (!this.state.isLoading && (
                            <div className="flex flex-col self-stretch flex-grow items-center justify-center mx-auto">
                                <Empty
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    description={suggestedSkills.length > 0 ?
                                        `Nothing here. Keep searching!` :
                                        `${TB.trans('talent.talent_skills_form.empty_skills_message')}${search}`}/>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        );
    }
}

ProjectSkillsForm.propTypes = {};

export default ProjectSkillsForm;

const styles = {
    fieldSectionCol: {
        flexDirection: 'column',
        alignItems: 'stretch'
    },
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0',
    },
};